import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import type { PurchaseOrderStatus } from '@/types'

const statusConfig: Record<PurchaseOrderStatus, { label: string; className: string }> = {
  draft: {
    label: 'Draft',
    className: 'bg-muted text-muted-foreground border-border',
  },
  in_progress: {
    label: 'In Progress',
    className: 'bg-blue-500/10 text-blue-400 border-blue-500/20',
  },
  estimated: {
    label: 'Estimated',
    className: 'bg-warning/10 text-warning border-warning/20',
  },
  finalized: {
    label: 'Finalized',
    className: 'bg-positive/10 text-positive border-positive/20',
  },
}

interface StatusBadgeProps {
  status: PurchaseOrderStatus
}

export default function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusConfig[status]

  return (
    <Badge
      variant="outline"
      className={cn('border font-medium', config.className)}
    >
      {config.label}
    </Badge>
  )
}
